module.exports = __webpack_public_path__ + "static/img/picture3.685bbf5e.png";